import { Provider } from "react-redux";
import { store } from './redux/store';
import { ToastContainer } from 'react-toastify';
import './assest/css/custom.css';
import MainRoutes from './routes/MainRoutes';
import 'react-confirm-alert/src/react-confirm-alert.css';
import 'cropperjs/dist/cropper.css';
import 'flatpickr/dist/flatpickr.min.css';
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

function App() {
  const { pathname } = useLocation();
  const ScrollToTop = () => {

    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    useEffect(() => {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 10); // Small delay to override browser behavior
    }, [pathname]);

    return null;
  };
  return (
    <>
      <ScrollToTop />
      <Provider store={store}>
        <ToastContainer />
        <MainRoutes />
      </Provider>
    </>
  );
}

export default App;
